const RFQ_TABS_CONFIG = [
  {
    key: "new",
    label: "New",
    status: ["Seller Intimation"],
    columns: [
      // { key: "#", label: "#" },
      { key: "requirementId", label: "ID" },
      { key: "title", label: "Title" },
      { key: "companyName", label: "Buyer Name" },
      { key: "createdAt", label: "Created On" },
      { key: "supplierLocation", label: "Buyer Location" },
      { key: "action", label: "Action" },
    ],
  },
  {
    key: "interested",
    label: "Interested in",
    defaultChild: "in-review",
    subTabs: [
      {
        key: "in-review",
        label: "In Review",
        status: ["Seller Interested"],
        columns: [
          { key: "buyerRequirementId", label: "ID" },
          { key: "buyerTitle", label: "Title" },
          { key: "buyerCompanyName", label: "Buyer Name" },
          { key: "rfqCreatedAt", label: "Created On" },
          { key: "buyerLocation", label: "Buyer Location" },
          { key: "status", label: "Status" },
        ],
      },
      {
        key: "shortlisted", // seller sees Sign NDA button
        label: "Shortlisted",
        status: ["Buyer Interested", "NDA Initiated"],
        columns: [
          { key: "buyerRequirementId", label: "ID" },
          { key: "buyerTitle", label: "Title" },
          { key: "buyerCompanyName", label: "Buyer Name" },
          { key: "rfqCreatedAt", label: "Created On" },
          { key: "buyerLocation", label: "Buyer Location" },
          { key: "nda", label: "NDA" },
        ],
      },
      {
        key: "in-discussion",
        label: "In Discussion",
        status: ["NDA Signed"], // Buyer and Seller Signed NDA
        columns: [
          { key: "buyerRequirementId", label: "ID" },
          { key: "buyerTitle", label: "Title" },
          { key: "buyerCompanyName", label: "Buyer Name" },
          { key: "rfqCreatedAt", label: "Created On" },
          { key: "buyerLocation", label: "Buyer Location" },
          { key: "discussion", label: "Discussion" },
        ],
      },
      {
        key: "closed",
        label: "Closed",
        status: ["Feedback Completed"], //["Won", "Lost"],
        columns: [
          { key: "buyerRequirementId", label: "ID" },
          { key: "buyerTitle", label: "Title" },
          { key: "buyerCompanyName", label: "Buyer Name" },
          { key: "rfqCreatedAt", label: "Created On" },
          { key: "buyerLocation", label: "Buyer Location" },
          { key: "status", label: "Status" },
        ],
      },
    ],
  },
  {
    key: "rejected",
    label: "Rejected",
    status: ["Seller Not Interested", "Buyer Rejected", "Lost"], //["Seller Not Interested", "Expired"],
    columns: [
      { key: "buyerRequirementId", label: "ID" },
      { key: "buyerTitle", label: "Title" },
      { key: "buyerCompanyName", label: "Buyer Name" },
      { key: "rfqCreatedAt", label: "Created On" },
      { key: "buyerLocation", label: "Buyer Location" },
      { key: "rejectionReason", label: "Rejection Reason" },
      { key: "status", label: "Status" },
    ],
  },
];

export default RFQ_TABS_CONFIG;
